import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router';

export function useSearchState<T>({
  initialValue,
  serialize,
  deserialize,
}: {
  initialValue: T;
  serialize: (value: T, params: URLSearchParams) => URLSearchParams;
  deserialize: (value: URLSearchParams) => T;
}) {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState<T>(
    () => deserialize(searchParams) || initialValue
  );

  const finalSetState = useCallback(
    (value: T) => {
      setState(value);

      const currentParams = new URLSearchParams(window.location.search);
      const newParams = serialize(value, currentParams);

      window.history.replaceState(
        null,
        '',
        window.location.pathname + '?' + newParams.toString()
      );
    },
    [serialize]
  );

  return [state, finalSetState] as const;
}
